import React from 'react';
import { useSelector } from 'react-redux';
import ChartHolder from '@/components/ChartHolder';
import { LINE } from '@/components/charting/chartType.constants';
import { getChartingOptions } from '@/store-selectors';
import { useConfiguredDataTable } from '@/features/queryMetricsDimensionsConfig/metricConfigSlice';
import { useAppSelector } from '@/store/hooks';
import { selectIsLoadingRows } from '@/features/query-builder/queryBuilderSlice';
import { LoadingTimer } from './LoadingTimer';

export const LineDataPresentation = () => {
  const dataTable = useConfiguredDataTable();
  const isLoading = useAppSelector(selectIsLoadingRows);
  const chartingOptions = useSelector(getChartingOptions);

  if (isLoading || !dataTable) return <LoadingTimer />;

  return (
    <ChartHolder
      // chartContainerHeight={chartContainerHeight}
      presentation={LINE}
      dataTable={dataTable}
      chartingOptions={chartingOptions}
    />
  );
};
